import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'amAdd' })
export class AddPipe implements PipeTransform {
  transform(value: any, amount: moment.DurationInputArg1, unit?: moment.DurationInputArg2): any {
    if (!value) {
      return value;
    }
    return moment(value).add(amount, unit);
  }
}
